import { ApolloClient, from, HttpLink, InMemoryCache } from '@apollo/client'
import {getBookmapAuthHeaders, isBridgeAvailable} from "../configs/bookmapBridge";
import { setContext } from '@apollo/client/link/context'
import { userManager } from 'core/configs/userManager'
import { API_URL } from 'core/constants'

const httpLink = new HttpLink({ uri: API_URL + '/api/dashboard/widgets/graphql' })

const authLink = setContext(async (_, { headers }) => {
  try {
    if (isBridgeAvailable()) {
      return {
        headers: {
          ...headers,
          ...(await getBookmapAuthHeaders().then()),
        },
      }
    }

    const token = (await userManager.getUser())?.access_token
    return {
      headers: {
        ...headers,
        ...(token && { authorization: `Bearer ${token}` }),
      },
    }
  } catch (error) {
    console.error('Error getting token', error)
    return { headers }
  }
})

export const graphQlClient = new ApolloClient({
  link: from([/*errorLink, */ authLink, httpLink]),
  cache: new InMemoryCache(),
})
